import React from "react"
import ReactPlayer from "react-player/lazy"

const KnowledgeArticleContentVideo = ({ value, controls = true, ...rest }) => (
  <ReactPlayer url={value} controls={controls} {...rest} />
)

export { KnowledgeArticleContentVideo }
